import React from "react";

const NoPage = () => {
  return (
    <div className="error">
      <h1>Page not found! Try Again</h1>
    </div>
  );
};

export default NoPage;
